// Text shared across the app (D146). Keys are "area.thing"; values may hold
// {name}-style holes filled by t().
export const common = {
  'common.save': 'Save',
  'common.cancel': 'Cancel',
  'common.close': 'Close',
  'common.done': 'Done',
  'common.back': 'Back',
  'common.delete': 'Delete',
  'common.remove': 'Remove',
  'common.retry': 'Retry',
  'common.somethingWrong': 'Something went wrong',
  // The server asked this app to update (HTTP 426, #82).
  'common.updateRequired.title':
    'Update Twinden to keep sending and reading new messages',
  'common.updateRequired.action': 'Update',
  'common.updateRequired.needsUpdate': 'needs an update of Twinden',
  // Waiting on the server (M66, D247–D249)
  'common.loading': 'Loading…',
  'common.loading.chats': 'Loading chats…',
  'common.loading.messages': 'Loading messages…',
  'common.loading.slow': 'Still loading… Twinden’s server is taking a while.',
  'common.loading.failed': 'This didn’t load.',
  'common.loading.offline': 'You’re offline. We’ll load it when you’re back.',
  'common.loading.tryAgain': 'Try again',
  // A device still without its key, in an encrypted family or chat (M28)
  'e2ee.keysNotReady':
    'This device is still getting its keys. Nothing was sent — try again in a moment.',
  // A sealed picture over the server's limit (M72)
  'e2ee.pictureTooLarge':
    'This picture is too big to send. Choose a smaller one.',
  // No family's key has reached this device to hold a picture's key (D292)
  'e2ee.pictureNoFamilyKey':
    'Your picture wasn’t set: this device doesn’t have your family’s keys yet. Try again in a moment.',
  // In no family yet: no one could see a picture (D292)
  'e2ee.pictureNoFamily': 'You can add a picture once you’re in a family.',
  // My sealed picture can't be opened anywhere any more (D295)
  'e2ee.pictureLost':
    'Your picture can’t be opened any more, so your family sees your initials. Set it again in your profile.',
  'common.you': 'You',
  'settings.language.title': 'Language & region',
  'settings.language.description':
    'The app’s words, and how dates, times and numbers look on this device.',
  'settings.language.label': 'Language',
  'settings.language.device': 'Same as this device',
  'settings.language.hint':
    'Messages stay as people wrote them; only Twinden’s own words change.',
} as const;
